import { APIClient } from "./api_helper";
const api = new APIClient();

const backend = `${process.env.REACT_APP_URL}empresa`;

export const controleAtendimento = (page: number, limit: number) =>
  api.get(`${backend}`, { page, limit, finalizou: "NAO", liberado: "SIM" });

export const addAutoAtendimentoCliente = (data: any) =>
  api.create(`${backend}/cliente/`, data);

export const addAlterarEmpresa = (data: any) => api.put(`${backend}`, data);

export const addAutoAtendimentoAutoAtendimento = (data: any) =>
  api.create(`${backend}/auto-atendimento/`, data);

export const painelControle = (
  page: number,
  limit: number,
  tipoEmpresa: string
) => api.get(`${backend}`, { page, limit, tipoEmpresa, finalizou: "NAO" });

export const finalizarAutoAtendimento = (data: any) =>
  api.patch(`${backend}/finalizar/${data.id}/`, {});

export const atendimentos = (page: number, limit: number) =>
  api.get(`${backend}`, { page, limit });

export const liberadaAutoAtendimento = (data: any) =>
  api.patch(`${backend}/liberada/${data.id}/`, {});

export const relatorio = (page: number, limit: number, data: string) =>
  api.get(`${backend}`, { page, limit, data });
